import React from "react";
import VisibilitySensor from "react-visibility-sensor";
import constants from "../assets/js/constants";
import {
  getVisibleSensorAnimation,
  setAdditionalClasses,
} from "../assets/js/utils";

function ColorfullTable({ rows = [], colorHeader = constants.COLORS.PRIMARY }) {
  return (
    <table className="colorfull-table">
      <thead>
        <VisibilitySensor partialVisibility>
          {({ isVisible }) => (
            <tr
              style={getVisibleSensorAnimation(
                isVisible,
                `fadeIn 1s backwards`
              )}
            >
              {rows[0].map((header, index) => (
                <th
                  className={`colorfull-table__column-heading${setAdditionalClasses(
                    ["first-column", "last-column", "center-text"],
                    [
                      index === 0,
                      index === rows[0].length - 1,
                      index === rows[0].length - 1,
                    ]
                  )}`}
                  key={index}
                  style={{ color: colorHeader }}
                >
                  {header}
                </th>
              ))}
            </tr>
          )}
        </VisibilitySensor>
      </thead>
      <tbody>
        {rows.map(
          (data, index) =>
            index > 0 && (
              <VisibilitySensor partialVisibility>
                {({ isVisible }) => (
                  <tr
                    key={index}
                    className={setAdditionalClasses(
                      ["last-row"],
                      [index === rows.length - 1]
                    )}
                    style={getVisibleSensorAnimation(
                      isVisible,
                      `fadeIn 1s ${index * 0.1}s backwards`
                    )}
                  >
                    {data.map((dataCell, index) => (
                      <td
                        className={`colorfull-table__content-data${setAdditionalClasses(
                          ["first-column", "last-column", "center-text"],
                          [
                            index === 0,
                            index === data.length - 1,
                            index === data.length - 1,
                          ]
                        )}`}
                        key={index}
                      >
                        {dataCell}
                      </td>
                    ))}
                  </tr>
                )}
              </VisibilitySensor>
            )
        )}
      </tbody>
    </table>
  );
}

export default ColorfullTable;
